import apiHelper from '@/utils/apiHelper';
import setCompsetsUpdatedFlag from '@/utils/setCompsetsUpdatedFlag';

const setVisibleProperties = async ({
  pipe,
  id,
  properties,
}) => {
  const res = await apiHelper(
    'PUT',
    `/${pipe}/visibility/${id}`,
    {
      properties,
    },
  );

  if ([200, 201, 204].indexOf(res.status) >= 0) {
    setCompsetsUpdatedFlag(true);
    return true;
  }

  return false;
};

export default setVisibleProperties;
